import React, { useState } from "react"
import { IMG } from "./common/CONST"
import * as TrinityAPI from "../requests/TrinityAPI"
import { useParams } from "react-router-dom"
import { IResetPasswordRequest } from "../types/user/IResetPasswordRequest"

export const Reset = () => {
  const [password, setPassword] = useState("")
  const [rePassword, setRePassword] = useState("")
  const [passwdError, setPasswdError] = useState("")
  const [success, setSuccess] = useState(false)
  const params = useParams()

  const submit = () => {
    setPasswdError("")
    if (password !== rePassword || password.trim().length === 0) {
      setPasswdError("Пароли не совпадают")
      return
    }
    if (!params.confirmation) {
      setPasswdError("Неверная ссылка восстановления пароля")
      return
    }
    let resetRequest: IResetPasswordRequest = {
      userId: Number(params.userId),
      confirmationString: params.confirmation,
      password: password
    }
    TrinityAPI.resetPassword(resetRequest, response => {
      if (response.status === 200) {
        setSuccess(true)
      }
    })
  }

  return (
    <div className="registration-container">
      <div className="reg-left-img-block">
        <img src={IMG.main_logo} alt="" className="img-main-enter" />
      </div>
      <div className="reg-right-block">
        <div className="block-form">
          <h2 className="heading-form">Новый пароль</h2>
          {success ? (
            <p className="text-block">
              Пароль успешно изменен. Теперь вы можете{" "}
              <a href="/signin" className="red-link fontsize-16">
                авторизоваться
              </a>
            </p>
          ) : (
            <>
              <fieldset>
                <legend>Пароль</legend>
                <input
                  type="password"
                  required
                  className="input-form"
                  placeholder="A—a Z—z 1 * / -"
                  onChange={e => setPassword(e.target.value)}
                />
              </fieldset>
              <fieldset>
                <legend>Повторите пароль</legend>
                <input
                  type="password"
                  required
                  className="input-form-error"
                  placeholder="A—a Z—z 1 * / -"
                  onChange={e => setRePassword(e.target.value)}
                />
                {passwdError ? <p className="error-form">{passwdError}</p> : <></>}
              </fieldset>
              <div className="flex-btn-justify">
                <input type="submit" value="Сохранить пароль" className="btn" onClick={submit} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
